import { action, computed, makeObservable, observable } from 'mobx';

import { Disturbance, DisturbanceLocation, DisturbanceType } from '@config/DisturbanceConfig';
import RootStore from '@stores/RootStore';
import SsoStore from '@stores/SsoStore';

export default class DisturbanceLocationModalStore {
  @observable accessor disturbance: Disturbance = null;
  @observable accessor location: DisturbanceLocation = null;
  @observable accessor type: DisturbanceType;
  @observable accessor modalIsOpen: boolean = false;

  private ssoStore: SsoStore;

  public constructor(rootStore: RootStore) {
    makeObservable(this);
    this.ssoStore = rootStore.ssoStore;
  }

  @computed
  public get customerId(): number {
    return this.ssoStore.customerId;
  }

  @computed
  public get affectedLocations(): DisturbanceLocation[] {
    if (this.disturbance && this.location) {
      return this.disturbance.location.filter(loc => loc.name == this.location.name);
    } else {
      return [];
    }
  }

  @action
  public openModal(disturbance: Disturbance, locValue: DisturbanceLocation, type: DisturbanceType) {
    if (!this.modalIsOpen && this.ssoStore.customerId) {
      this.type = type;
      this.disturbance = disturbance;
      this.location = locValue;
      this.modalIsOpen = true;
    }
  }

  @action
  public continueModal() {
    if (this.disturbance && this.location) {
      this.modalIsOpen = true;
    }
  }

  @action
  public closeModal() {
    this.modalIsOpen = false;
    this.disturbance = null;
    this.location = null;
  }
}
